
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 90 90","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 90h90V0H0v90zm11.2-63.8h67.5V30H11.2v-3.8zm0 16.9h67.5v3.8H11.2v-3.8zm0 16.9h67.5v3.8H11.2V60z","fill-rule":"nonzero"}})])
          )
        }
      }
    


// WEBPACK FOOTER //
// ./src/assets/management/data.svg